import type { Editor } from '@tiptap/react';
import { create } from 'zustand';

type TipTapEditorStore = {
  editor: Editor | null;
  setEditor: (editor: Editor | null) => void;
  token: string | null;
  setToken: (token: string | null) => void;
  isTipTapEnabled: boolean;
  setIsTipTapEnabled: (enabled: boolean) => void;
};

export const useTipTapEditor = create<TipTapEditorStore>(set => ({
  editor: null,
  setEditor: editor => set({ editor }),
  token: null,
  setToken: token => set({ token }),
  isTipTapEnabled: false,
  setIsTipTapEnabled: enabled => set({ isTipTapEnabled: enabled }),
}));
